import axios from "axios";
import { buildApiUrl, getApiBaseUrl } from "../config/api";

export const FEE_AID_TYPES = ["Waiver", "Scholarship", "Bursary", "GovSubsidy"];

export async function fetchFeeAids(schoolId, filters = {}) {
    const { data } = await axios.get(buildApiUrl(`/FeeAid/${schoolId}`), { params: filters });
    return Array.isArray(data) ? data : [];
}

export async function createFeeAid(payload) {
    const { data } = await axios.post(buildApiUrl("/FeeAid"), payload);
    return data;
}

export async function updateFeeAid(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/FeeAid/${id}`), payload);
    return data;
}

export async function revokeFeeAid(id) {
    const { data } = await axios.put(buildApiUrl(`/FeeAid/${id}/revoke`));
    return data;
}

export async function fetchSubsidyReport(schoolId, { academicYear, term } = {}) {
    const params = {};
    if (academicYear) params.academicYear = academicYear;
    if (term) params.term = term;
    const { data } = await axios.get(buildApiUrl(`/FeeReport/subsidy/${schoolId}`), { params });
    return data;
}

export async function downloadReceiptPdf(feeRecordId, receiptNumber) {
    const response = await axios.get(
        `${getApiBaseUrl()}/FeeRecord/${feeRecordId}/receipt/${receiptNumber}/pdf`,
        { responseType: "blob" },
    );
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${receiptNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export async function sendBulkDefaulterReminders(schoolId, payload) {
    const { data } = await axios.post(buildApiUrl(`/FeeReport/defaulters/${schoolId}/bulk-reminder`), payload);
    return data;
}
